export default __webpack_public_path__ + "static/media/PipeSupportWallHole.64.747c260f.png";